import React from 'react';
import Icon from '../../../components/AppIcon';
import PlayerCard from './PlayerCard';

const SquadPanel = ({ squadPlayers, squadByRole, onRemovePlayer, tournament, pendingChanges = [] }) => {
  const maxSquadSize = 25;
  const squadSize = squadPlayers?.length || 0;
  const squadProgress = (squadSize / maxSquadSize) * 100;

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold text-foreground">Tournament Squad</h2>
          <div className="flex items-center gap-2">
            {pendingChanges?.length > 0 && (
              <span className="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 px-2 py-1 rounded-full">
                Unsaved
              </span>
            )}
            <span className="text-sm font-medium text-muted-foreground">
              {squadSize} / {maxSquadSize} players
            </span>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all ${
              squadSize >= maxSquadSize ? 'bg-green-500' :
              squadSize >= maxSquadSize * 0.7 ? 'bg-yellow-500': 'bg-primary'
            }`}
            style={{ width: `${Math.min(squadProgress, 100)}%` }}
          />
        </div>
        
        {squadSize >= maxSquadSize && (
          <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-2">
            Squad is full. Remove players to add new ones.
          </p>
        )}
      </div>

      <div className="space-y-4 max-h-[600px] overflow-y-auto">
        {squadSize === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            <Icon name="Users" className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>No players in squad</p>
            <p className="text-sm mt-1">Add players from the available list</p>
          </div>
        ) : (
          Object.entries(squadByRole)?.map(([role, players]) => (
            players?.length > 0 && (
              <div key={role}>
                <h3 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
                  <Icon name="Users" className="w-4 h-4" />
                  {role} ({players?.length})
                </h3>
                <div className="space-y-2">
                  {players?.map((player) => (
                    <PlayerCard
                      key={player?.playerId}
                      player={player}
                      onAction={() => onRemovePlayer(player)}
                      actionIcon="X"
                      actionLabel="Remove from Squad"
                    />
                  ))}
                </div>
              </div>
            )
          ))
        )}
      </div>

      {/* Squad Summary */}
      {squadSize > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <h3 className="text-sm font-semibold text-foreground mb-2">Squad Balance</h3>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(squadByRole)?.map(([role, players]) => (
              <div key={role} className="p-2 bg-muted/30 rounded">
                <p className="text-xs text-muted-foreground">{role}</p>
                <p className="text-lg font-semibold text-foreground">{players?.length}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SquadPanel;